<template>
  <div style="min-height: 750px;">
    <support-list></support-list>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as SupportList
} from '@/wam/components/widgets/SupportList';
import { mapGetters } from 'vuex';
import moment from "moment";
export default {
  name: 'user_support_list',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    SupportList,
  },
  props: {},
  data () {
    return {
      d_user: '',
    };
  },
  created: function () {
  },
  beforeMount () {},
  mounted: function () {
  },
  methods: {},
  watch: {}
};

</script>

